import { Component } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { FloorplanCableRouteMenuComponent } from "@project/floorplanner/floorplan-menu/fgds/wiring-menu/cable-route-menu/floorplan-cable-route-menu.component";
import { FloorplanProtectiveTubesMenuComponent } from "@project/floorplanner/floorplan-menu/fgds/wiring-menu/floorplan-protective-tubes-menu/floorplan-protective-tubes-menu.component";
import { FloorplanPipelinesMenuComponent } from "@project/floorplanner/floorplan-menu/fgds/wiring-menu/pipelines-menu/floorplan-pipelines-menu.component";
import { FloorplanWiresMenuComponent } from "@project/floorplanner/floorplan-menu/fgds/wiring-menu/wires-menu/floorplan-wires-menu.component";

@Component({
  selector: "app-floorplan-wiring-menu",
  templateUrl: "./floorplan-wiring-menu.component.html",
  styleUrls: ["./floorplan-wiring-menu.component.scss"],
  imports: [
    UiKitModule,
    FloorplanPipelinesMenuComponent,
    FloorplanCableRouteMenuComponent,
    FloorplanWiresMenuComponent,
    FloorplanProtectiveTubesMenuComponent,
  ],
})
export class FloorplanWiringMenuComponent {}
